<template>
  <Dialog v-model:open="isOpen">
    <DialogScrollContent class="tw-max-w-3xl" is-static-backdrop>
      <DialogHeader>
        <DialogTitle>Manage Assets</DialogTitle>
      </DialogHeader>
      <div class="tw-px-6">
        <Tabs
          v-model="currentTab"
        >
          <TabsList class="tw-border-b-0 tw-mb-4">
            <TabsTrigger
              :value="tabUploadId"
              variant="pill"
            >
              Upload
            </TabsTrigger>
            <TabsTrigger
              :value="tabLibraryId"
              variant="pill"
            >
              Library
            </TabsTrigger>
          </TabsList>
          <TabsContent
            :value="tabLibraryId"
          >
            <team-asset-list />
          </TabsContent>
          <TabsContent
            :value="tabUploadId"
          >
            <team-asset-upload
              :override-allow-extension-list="overrideAllowExtensionList"
              @uploaded="onUploaded"
            />
          </TabsContent>
        </Tabs>

        <team-asset-sharing-form ref="teamAssetSharingFormRef" />
      </div>
      <DialogFooter>
        <button
          v-if="teamAssetSelected"
          type="button"
          class="btn btn-primary"
          @click="selectTeamAsset"
        >
          Select
        </button>

        <DialogClose as-child>
          <button
            type="button"
            class="btn btn-secondary"
          >
            Close
          </button>
        </DialogClose>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>

<script>
import { computed, ref, watch } from 'vue'
import TeamAssetList from './team-asset-list.vue'
import TeamAssetUpload from './team-asset-upload.vue'
import TeamAssetSharingForm from './team-asset-sharing-form.vue'
import { useProvideTeamAssets } from './use-team-assets'
import uniqueId from 'lodash/uniqueId'
import {
  Dialog,
  DialogClose,
  DialogFooter,
  DialogHeader,
  DialogScrollContent,
  DialogTitle
} from '@/shadcn/components/ui/dialog'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shadcn/components/ui/tabs/index.js'

export default {
  name: 'TeamAssetPicker',
  components: {
    TabsContent,
    TabsTrigger,
    TabsList,
    Tabs,
    TeamAssetSharingForm,
    TeamAssetList,
    TeamAssetUpload,
    Dialog,
    DialogClose,
    DialogFooter,
    DialogHeader,
    DialogScrollContent,
    DialogTitle
  },
  inheritAttrs: false,
  props: {
    category: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object
    },
    overrideAllowExtensionList: {
      type: Array,
      required: false,
      default: () => null
    }
  },
  emits: ['update:modelValue', 'hide'],
  setup (props, { emit, expose }) {
    const modalId = uniqueId('TeamAssetPicker_')
    const tabUploadId = `${modalId}-upload-tab`
    const tabLibraryId = `${modalId}-library-tab`
    const currentTab = ref(tabUploadId)

    const isOpen = ref(false)
    const category = computed(() => props.category)

    const { teamAssetSelected, teamAssetSharingFormRef } = useProvideTeamAssets(category)

    const show = () => {
      teamAssetSelected.value = undefined
      isOpen.value = true
    }

    const onUploaded = teamAsset => {
      teamAssetSelected.value = teamAsset
      selectTeamAsset()
    }

    const selectTeamAsset = () => {
      if (teamAssetSelected.value) {
        emit('update:modelValue', teamAssetSelected.value)
        isOpen.value = false
      }
    }

    watch(isOpen, (newValue) => {
      if (!newValue) {
        emit('hide')
      }
    })

    expose({
      show
    })

    return {
      modalId,
      tabUploadId,
      tabLibraryId,
      currentTab,
      isOpen,
      teamAssetSelected,
      teamAssetSharingFormRef,
      onUploaded,
      selectTeamAsset
    }
  }
}
</script>
